import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import checkValue from '../../../../../../../../utils/values';
import FiduciaPdf from '../../../DownloadPdf/components/FiduciaPdfComponents';

function PdfGlobalTedIncome() {
  const incomeFaresState = useSelector(
    (reducer: IReducer) => reducer.incomeFares
  );

  return (
    <>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Tarifas de TEV recebidas:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.tev.received).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Tarifas de TEV repassadas:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.tev.passedOn).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Receita obtida com TEV:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.tev.income).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
    </>
  );
}

export default PdfGlobalTedIncome;
